import React, { Component } from 'react'
import {Image} from 'react-bootstrap';
import edit from '../assets/edittable.png'
import deletee from '../assets/delete.png'


export default class DeleteButton extends Component {

    deleteitem(){
        this.props.delete(this.props.value)
    }

    edititem(){
        this.props.edit(this.props.value)
    }

    render() {
        return (
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',minWidth:'100%'}}>
                <div><Image className="myButton" style={{height:'15px'}} src={deletee} onClick={this.deleteitem.bind(this)}/></div>
                <div><Image className="myButton" style={{height:'15px'}} src={edit} onClick={this.edititem.bind(this)}/></div>
            </div>
            
        )
    }
}
